module.exports = __webpack_public_path__ + "img/xhd.2a857731.png";